<template>
    <NuxtLayout>
        <div
            data-page
            class="py-20 container-extra-wide mx-auto"
        >
            <div class="flex items-center justify-center">
                <div class="flex flex-col justify-center items-center space-y-4">
                    <p class="text-center text-neutral-base text-sm leading-sm font-ux font-semibold">
                        {{ error.statusCode }}
                    </p>
                    <h1 class="text-center text-5xl leading-5xl font-brand-heading text-heading font-heading">
                        {{ error.statusMessage ?? 'Something went wrong' }}
                    </h1>

                    <div
                        v-if="error.message"
                        class="flex justify-center max-w-[450px] text-center "
                    >
                        <p
                            class="text-(--text-body) text-base leading-base whitespace-pre-wrap"
                            v-html="error.message"
                        />
                    </div>

                    <div class="w-full flex justify-center pt-10"> 
                        <DButton size="lg" @click="handleClearError">Back to homepage</DButton>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    defineProps({
        error: Object
    })

    const { homeUri } = storeToRefs(useGlobalStore())

    const handleClearError = async () => {
        await clearError({ redirect: homeUri.value ?? '/' })
    }
</script>
